export default __webpack_public_path__ + "static/media/brain-test.617b24b5.webp";